import { render, staticRenderFns } from "./RotatedHeader.vue?vue&type=template&id=4b7faa2b&scoped=true&"
import script from "./RotatedHeader.vue?vue&type=script&lang=js&"
export * from "./RotatedHeader.vue?vue&type=script&lang=js&"
import style0 from "./RotatedHeader.vue?vue&type=style&index=0&id=4b7faa2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7faa2b",
  null
  
)

export default component.exports